import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MapDetailService } from '../../../services/map-detail.service';

interface ThsrTrain {
  trainNo: string;
  departure: string;
  arrival: string;
  startStop:string;
  endStop:string;
  nextStop:string;
}

@Component({
  selector: 'thsr-traffic',
  standalone: true,
  template:`
  <div class="detail collapse {{ state }}" id="thsr">
    <div class="card card-body">
      <a (click)="close()" role="button" aria-expanded="false" aria-controls="thsr" class="bt-close">
        <span aria-hidden="true" class="close">×</span>
      </a>
      <div class="site-tt">站點資訊</div>
      <div class="ic_tit">
        <div><div class="icon"><img src="/static/images/svg/map_w_thsr.svg" alt=""></div>臺中</div>
        <a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset_bk.svg" alt=""></a>
	    </div>

    <ul class="nav nav-tabs" id="myTab1" role="tablist">
      <li class="nav-item">
        <a (click)="getTrain()" class="nav-link active" id="north-tab1" data-toggle="tab" href="#north1" role="tab" aria-controls="north" aria-selected="true">北上</a>
      </li>
      <li class="nav-item">
        <a (click)="getTrain()" class="nav-link" id="south-tab1" data-toggle="tab" href="#south1" role="tab" aria-controls="south" aria-selected="false">南下</a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent1">
      <div class="tab-pane fade show active" id="north1" role="tabpanel" aria-labelledby="north-tab">
        <ul class="box mrt">
          <li class="titbox">
            <div class="m-title"><p>北上列車</p></div>
          </li>
          @for (Nouthtrain of NouthtrainList; track $index) {
            <li class="timelist">
            <p class="subtit">臺中 {{ Nouthtrain.trainNo }} ( {{ Nouthtrain.startStop }} → {{ Nouthtrain.endStop }} )</p>
            <div class="time">
              <p class="in">預計 {{ Nouthtrain.departure }} 出發 → {{ Nouthtrain.arrival }} 抵達</p>
              <div class="d-flex"><span class="arrow"></span><p class="next">{{ Nouthtrain.nextStop }}</p></div>
            </div>
          </li>
         }
        </ul>
      </div>

      <div class="tab-pane fade" id="south1" role="tabpanel" aria-labelledby="south-tab">
        <ul class="box mrt">
          <li class="titbox">
            <div class="m-title"><p>南下列車</p></div>
          </li>
          @for (Southtrain of SouthtrainList; track $index) {
            <li class="timelist">
            <p class="subtit">臺中 {{ Southtrain.trainNo }} ( {{ Southtrain.startStop }} → {{ Southtrain.endStop }} )</p>
            <div class="time">
              <p class="in">預計 {{ Southtrain.departure }} 出發 → {{ Southtrain.arrival }} 抵達</p>
              <div class="d-flex"><span class="arrow"></span><p class="next">{{ Southtrain.nextStop }}</p></div>
            </div>
          </li>
         }
        </ul>
	  </div>
    </div>
  </div>
</div>
  `
})

export class ThsrTrafficComponent {

  // [ClienteService] 定義服務
  constructor(private mapDetailService: MapDetailService) {
  }

  @Input() name: string = "";
  @Output() callBack =  new EventEmitter<void>();
  state:string =""
  NouthtrainList:ThsrTrain[] = []
  SouthtrainList:ThsrTrain[] = []

  ngOnChanges(){
    this.state = "show";
    if(this.state = "show") {
      this.getTrain();
    }
  }
  close(){
    this.callBack.emit();
  }

  getTrain() {
    this.mapDetailService.getThsr("North").subscribe((ThsrObject:any) => {
      this.NouthtrainList = [];
      for(let thsr of ThsrObject){
        this.NouthtrainList.push({
          trainNo:   thsr.trainNo,
          departure: thsr.departure,
          arrival:   thsr.arrival,
          startStop: thsr.startStop,
          endStop:   thsr.endStop,
          nextStop:  thsr.nextStop
        })
      }
    });

    this.mapDetailService.getThsr("South").subscribe((ThsrObject:any) => {
      this.SouthtrainList = [];
      for(let thsr of ThsrObject){
        this.SouthtrainList.push({
          trainNo:   thsr.trainNo,
          departure: thsr.departure,
          arrival:   thsr.arrival,
          startStop: thsr.startStop,
          endStop:   thsr.endStop,
          nextStop:  thsr.nextStop
        })
      }
    });
  }



}
